<div class="login-container">
  <div class="message-section">
    <div class="label1">Your signup was successfull!</div>
    <div class="label2">An email has been sent to your registered email-id.</div>
    <div class="label3">Check your email to proceed..</div>
  </div>
  <div class="img-section">
    <img src="../../../assets/images/icon 06.png" alt="">
  </div>
</div>